module.exports = __webpack_public_path__ + "media/music1.1dc7cd4b.mp3";